import { Heading } from 'components/v2/Typography/Heading';
import { themes } from 'kb-shared';
import styled from 'styled-components';

import { Status } from './BubbleStep.types';

type StatusProps = {
  status: Status;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const BubbleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export const StepTitle = styled(Heading)`
  display: block;
  text-align: center;
`;

export const Spacer = styled.div<StatusProps>`
  border-radius: 6px;
  width: 56px;
  height: 6px;
  margin-top: 13px;
  flex-shrink: 0;
  background-color: ${themes.colors.yellow.primary};

  @media ${({ theme }) => theme.queries.maxTablet} {
    width: 28px;
    margin: 13px 8px 0;
  }
`;
